export default __webpack_public_path__ + "static/media/previous.022264e8.svg";